import { ClientFormData } from '../types';
import { CreateClientRequest } from '../types/dto/request/create-client.dto';
import { UpdateClientRequest } from '../types/dto/request/update-client.dto';
import { mapClientIntegrationsToDTO } from './client-integration.mapper';
import { mapClientPaymentTermsToDTO } from './client-payment-terms.mapper';

/**
 * Maps ClientFormData to CreateClientRequest with avatar
 * Transforms domain model to DTO structure for client creation
 * Includes avatar file for post-creation upload
 */
export const mapClientFormDataToCreateRequest = (
  formData: ClientFormData
): CreateClientRequest & { avatar?: File } => {
  const integrationsDTO = mapClientIntegrationsToDTO(formData.integrations);

  return {
    info: {
      name: formData.name,
      defaultPaymentTerms: mapClientPaymentTermsToDTO(formData.paymentTerms),
      email: formData.email || '',
      managerId: formData.managerId ? Number(formData.managerId) : null,
      billTo: formData.billingAddress || '',
      shipTo: formData.shippingAddress || '',
    },
    integrations: integrationsDTO
      ? {
          integrations: integrationsDTO,
        }
      : undefined,
    avatar: formData.avatar,
  };
};

/**
 * Maps ClientFormData to UpdateClientRequest
 * Transforms domain model to DTO structure for client updates
 */
export const mapClientFormDataToUpdateRequest = (
  formData: ClientFormData,
  clientId: string
): UpdateClientRequest => {
  return {
    id: Number(clientId),
    name: formData.name,
    defaultPaymentTerms: mapClientPaymentTermsToDTO(formData.paymentTerms),
    email: formData.email || '',
    managerId: formData.managerId ? Number(formData.managerId) : null,
    billTo: formData.billingAddress || '',
    shipTo: formData.shippingAddress || '',
  };
};
